import { AfterViewChecked, Component, EventEmitter, Input, NgZone, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService, Message } from 'primeng/api';
import { FAZILService, User, UserService } from 'src/app/core';
import { UIService } from 'src/app/core/services/ui.service';
import { environment } from 'src/environments/environment';

import { AdministracionService } from 'src/app/administracion/administracion.service';
import { validateDni } from 'src/app/shared/helpers';
import { validateRUC } from 'src/app/shared/helpers';
import { validateEmail } from 'src/app/shared/helpers';

import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { FazilController } from 'src/app/core/fazil-controller-component';

import { Subscription } from 'rxjs';
import { Subject as SubjectRXJS } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { PlanOrganizacion } from 'src/app/modelo/PlanOrganizacion';
import { FormBuilder } from '@angular/forms';

@Component({
    selector: 'app-suscripcion-buscador',
    templateUrl: './suscripcion-buscador.component.html',
    styleUrls: ['./admin-suscripciones.component.scss']
})
export class SuscripcionBuscadorComponent  extends FazilController  implements OnInit, AfterViewChecked {

    //Variables de configuración/mensajes
    appConfig = environment.settings;

    errors: Object = {};
    msgs: Message[] = [];

    _plan: PlanOrganizacion = new PlanOrganizacion();
    
    procesando: boolean = false;

    //interacción con el popup
    
    results: PlanOrganizacion[] = [];
    resultsFiltered: PlanOrganizacion[] = [];
    processFilter:boolean = false;
    
    filterDebounceTime: number = 500;
    filterTextChanged: SubjectRXJS<any> = new SubjectRXJS<any>();

    constructor(
        private zone: NgZone,
        private router: Router,
        private route: ActivatedRoute,
        private fazilService: FAZILService,
        private confirmationService: ConfirmationService,
        private sanitizer: DomSanitizer,
        public override uiService: UIService,
        public override messageService: MessageService,
        public override administracionService: AdministracionService,
        public override _formBuilder: FormBuilder
    ) {
        super(uiService, messageService, administracionService, _formBuilder);
    }
    
    ngOnInit(): void {
        this.initComponent();
    }
    
    ngAfterViewChecked(): void {
        //dummy
    }
    
    //Detecta los cambios desde fuera del componente
//    ngOnChanges(changes: SimpleChanges): void {
//        //TODO Entender para que es
//        //throw new Error('Method not implemented.');
//    }
//    
    async initComponent() {
    }
    
    async filteredSuscripcionByKeyword($event) {
        if (this.filterTextChanged.observers.length === 0) {
            this.filterTextChanged.pipe(debounceTime(this.filterDebounceTime), distinctUntilChanged()).subscribe(async query => {
                if (query.$event.target.value.length == 13) {
                    this.processFilter = true;
                    const keyword = query.$event.target.value.toLocaleLowerCase();
                    const data = await this.administracionService.getPlanesOrganizacionPorRUCData(keyword);
                    this.resultsFiltered = data;
                    this.processFilter = false;
                }
            });
        }
        this.filterTextChanged.next({ $event });
    }
    
}
